export default "__VITE_ASSET__CPGob169__"